import { ListItem, ListItemButton, Stack, Typography } from '@mui/material'
import type { Relation } from '../api/api'

export interface RelationsListProps {
  relations: Relation[]
  onClickRelation: (relationId: string) => void
}

export const RelationsList = ({ relations, onClickRelation }: RelationsListProps) => {
  const sortedRelations = relations.toSorted((a, b) => a.name.localeCompare(b.name))

  return (
    <Stack
      sx={{
        gap: 0,
      }}
    >
      {sortedRelations.map((relation) => (
        <RelationRow
          key={relation.id}
          onClickRelation={() => onClickRelation(relation.id)}
          name={relation.name}
          count={relation.relatives.length}
        />
      ))}
    </Stack>
  )
}

interface RelationRowProps {
  name: string
  count: number
  onClickRelation: () => void
}

const RelationRow = ({ name, count, onClickRelation }: RelationRowProps) => {
  return (
    <ListItem sx={{ padding: 0 }}>
      <ListItemButton onClick={onClickRelation}>
        <Stack
          direction="row"
          sx={{
            padding: 2,
            flex: 1,
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Stack
            sx={{
              gap: 1,
            }}
          >
            <Typography data-testid="template-external-name" variant="p2Regular">
              {name}
            </Typography>
          </Stack>
          <Stack
            sx={{
              justifySelf: 'flex-end',
            }}
          >
            <Typography variant="p3Medium">{count} plans</Typography>
          </Stack>
        </Stack>
      </ListItemButton>
    </ListItem>
  )
}
